<template>
    <button class="btn" :disabled="loading">
        <i v-if="loading" class="fa fa-spinner fa-spin"></i>
        <slot />
    </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
}
</script>